import { ref } from "vue";
import useAuthStore from "@/stores/auth";

export default function useMiddleware() {
  const isAdmin = ref(false);
  const isSuperAdmin = ref(false);
  const isUser = ref(false);

  if (Object.keys(useAuthStore().user).length > 0) {
    isAdmin.value = useAuthStore().user.roles.some((e) =>
      ["Admin", "Super Admin"].includes(e)
    );
    isSuperAdmin.value = useAuthStore().user.roles.some((e) =>
      ["Super Admin"].includes(e)
    );
    isUser.value = useAuthStore().user.roles.some((e) =>
      ["Default", "Admin"].includes(e)
    );
  }

  return { isAdmin, isSuperAdmin, isUser };
}
